import Swiper from 'swiper';
import { Grid } from 'swiper/modules';

export function mainCategoriesSlider() {
	new Swiper(
		'.main-categories__content .main-categories__slider',
		{
			modules: [Grid],
			navigation: false,
			pagination: false,
			breakpoints: {
				320: {
					slidesPerView: 'auto',
					spaceBetween: 8,
					grid: {
						rows: 2,
						loopAddBlankSlides: true,
						fill: 'row',
					},
				},
				768: {
					spaceBetween: 12,
					slidesPerView: 'auto',
					grid: {
						rows: 2,
						loopAddBlankSlides: true,
						fill: 'row',
					},
				},
				1024: {
					spaceBetween: 47,
					slidesPerView: 'auto',
					grid: {
						rows: 2,
						loopAddBlankSlides: true,
						fill: 'row',
					}
				}
			},
		}
	);
}
